export default __webpack_public_path__ + "static/media/20_1_4.2ff20db4.png";